import React from 'react';
import './style.scss';
import {
	book,
	logo,
	eye,
	filter,
	download,
	trash,
	print,
	pencil,
	logout,
	user,
	search,
	chevronDown,
	chevronUp,
	plus,
	mobileLogo,
	times,
	chevronLeft,
	chevronRight,
	check,
	minus,
	addTasks,
	login,
	newTest,
	saveTest,
	selectFilter,
	spinner,
} from '../../assets/icons';

const Icon = (props) => {
	const getIcon = (name) => {
		switch (name) {
			case 'book':
				return book;
			case 'logo':
				return logo;
			case 'eye':
				return eye;
			case 'filter':
				return filter;
			case 'download':
				return download;
			case 'trash':
				return trash;
			case 'print':
				return print;
			case 'pencil':
				return pencil;
			case 'logout':
				return logout;
			case 'user':
				return user;
			case 'search':
				return search;
			case 'chevron-down':
				return chevronDown;
			case 'chevron-up':
				return chevronUp;
			case 'chevron-left':
				return chevronLeft;
			case 'chevron-right':
				return chevronRight;
			case 'plus':
				return plus;
			case 'mobile-logo':
				return mobileLogo;
			case 'times':
				return times;
			case 'check':
				return check;
			case 'minus':
				return minus;
			case 'add-tasks':
				return addTasks;
			case 'login':
				return login;
			case 'new-test':
				return newTest;
			case 'save-test':
				return saveTest;
			case 'select-filter':
				return selectFilter;
			case 'spinner':
				return spinner;
			default:
				return () => {};
		}
	};
	const setProperties = (width, height, color) => (icon) => icon(width, height, color);
	return (
		<span
			className={`icon ${props.className}`}
			{...props}
			dangerouslySetInnerHTML={{
				__html: setProperties(props.width, props.height, props.color)(getIcon(props.name)),
			}}
		/>
	);
};

export default Icon;
